import React, { useState, useEffect } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06); */
  border: none;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
  /* box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06); */
`;

const DishImageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

const DishImage = styled.div`
  background-image: ${(props) => `url(${props.$imageUrl})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

const PlaceholderOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  font-size: 14px;
  text-align: center;
  opacity: 0.7;
`;

const PlaceholderIcon = styled.div`
  width: 48px;
  height: 48px;
  background: #e2e8f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  font-size: 24px;
`;



const DishImageComponent = ({ dish }) => {
  const [finalImageUrl, setFinalImageUrl] = useState(null);
  const [, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // For dishes, we'll use a placeholder image or the dish image if available
    const dishImageUrl = dish?.image || "/assets/icons/svg/default-image-placeholder.svg";
    setFinalImageUrl(dishImageUrl);
    setImageLoaded(false);
    setImageError(false);
  }, [dish]);

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(false);
  };

  const isPlaceholder = !dish?.image || imageError;

  return (
    <Container>
      <ImageWrapper>
        <DishImageContainer>
          <DishImage 
            $imageUrl={finalImageUrl} 
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
          {isPlaceholder && (
            <PlaceholderOverlay>
              <PlaceholderIcon>
                🍽️
              </PlaceholderIcon>
              <div>
                <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                  {dish?.name || 'Dish Image'}
                </div>
                <div style={{ fontSize: '12px', opacity: 0.8 }}>
                  No image available
                </div>
              </div>
            </PlaceholderOverlay>
          )}
        </DishImageContainer>
      </ImageWrapper>
    </Container>
  );
};

export default DishImageComponent;